import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  editAgentProfileUpdate,
  getUserProfile,
} from "reduxStore/action/userProfileAction";
import { editUserProfileUpdate } from "reduxStore/action/userProfileAction";
import { AutocompletePlace } from "component/common/PlacesAutocomplete";
import Breadcrumb from "component/common/breadcrumb";
import strings from "translate/language";
import {
  getAge,
  nameValid,
  handleDetailResponse,
  seo,
  handleListResponse,
  ValidateExtensionImge,
} from "utils/utils";
import ProfileAvatar from "component/common/ProfileAvatar";
import { resolveProfileImageSrc } from "utils/profileImage";
import moment from "moment";
import Select from "react-select";
import { getCityList } from "reduxStore/action/masterActions";
import Input from "../../component/Input";

const UserEditPorfile = () => {
  const navigate = useNavigate();
  const [formVaild, setFormVaild] = useState({});
  const [form, setForm] = useState({});
  const [cityData, setCityData] = useState([]);
  const [image, setImage] = useState({ preview: "", raw: "" });
  const dispatch = useDispatch();
  const navigatpage = async (navname) => {
    navigate(navname);
  };
  const userProfileDetailSelector = useSelector(
    (state) => state?.userProfileUpdate
  );
  const GetCityListSelector = useSelector((state) => state.cityMasterData);

  useEffect(() => {
    if (GetCityListSelector.response) {
      const { response } = GetCityListSelector;
      if (response.status === 200) {
        setCityData(handleListResponse(response?.data));
      }
    }
  }, [GetCityListSelector]);

  const handleChange = (e) => {
    if (e.target.files.length) {
   
      const validFile = ValidateExtensionImge(e.target.files[0]);
      let preview = "";
      let image = "";
      if (validFile === true) {
        preview = URL.createObjectURL(e.target.files[0]);
        image = e.target.files[0];
        setFormVaild({
          ...formVaild,
          images: null,
          validMedia: null,
        });
      } else {
        preview = "";
        image = "";
        setFormVaild({
          ...formVaild,
          images: null,
          validMedia: validFile,
        });
      }
      const nextFormState = {
        preview: preview,
        raw: image,
      };
      setImage(nextFormState);
    }
  };
  const loginSelector = useSelector((state) => state.login);

  useEffect(() => {
    if (loginSelector.response) {
      const { response } = loginSelector;
      if (response.status === 200) {
        setForm(handleDetailResponse(response?.data));
      }
    }
  }, [loginSelector]);
  useEffect(() => {
    dispatch(getCityList());
  }, [dispatch]);

  useEffect(() => {
    if (userProfileDetailSelector.create === true) {
      if (userProfileDetailSelector?.response?.status === 200) {
        // setForm({});
        navigatpage(-1);
        dispatch(
          getUserProfile({
            user_id: handleDetailResponse(loginSelector.response?.data)?._id,
            cp_id: handleDetailResponse(loginSelector.response?.data)?.cp_id,
            role_id: handleDetailResponse(loginSelector.response?.data)
              ?.role_id,
          })
        );
      }
    }
    if (userProfileDetailSelector.detail === true) {
      if (userProfileDetailSelector?.response?.status === 200) {
        const { response } = userProfileDetailSelector;
        const data = handleDetailResponse(response.data);
        setForm({
          user_id: data?.user_id,
          agent_id: data?.cp_id ? data?.cp_id : null,
          role_id: data?.role_id,
          firstname: data?.firstname,
          agent_name: data?.agent_name ? data?.agent_name : null,
          lastname: data?.lastname,
          email: data?.email,
          mobile: data?.primary_mobile ? data?.primary_mobile : data?.mobile,
          primary_mobile: data?.primary_mobile,
          gender: data?.gender,
          dateofbirth: data?.date_of_birth
            ? moment(data?.date_of_birth).format("yyyy-MM-DD")
            : moment(data?.dateofbirth).format("yyyy-MM-DD"),
          date_of_birth: moment(data?.date_of_birth).format("yyyy-MM-DD"),
          address: data?.address,
          city: data?.city
            ? data?.city
            : cityData.find((i) => i.city_id === data?.city_id)?.city_name,
          cityObj: cityData.find((i) => i.city_id === data?.city_id),
          city_id: data?.city_id,
          area: data?.location ? data?.location : data?.area,
          location: data?.location,
          longitude: data?.longitude,
          latitude: data?.latitude,
          justo_employee_code:data?.justo_employee_code
        });
        let baseUrl = data?.cp_id ? data?.profile_base_url : data?.base_url;
        setImage({
          preview: resolveProfileImageSrc({
            baseUrl,
            profilePicture: data?.profile_picture,
          }),
        });
      }
    }
  }, [userProfileDetailSelector, GetCityListSelector]);

  useEffect(() => {
    dispatch(
      getUserProfile({
        user_id: handleDetailResponse(loginSelector.response?.data)?._id,
        cp_id: handleDetailResponse(loginSelector.response?.data)?.cp_id,
        role_id: handleDetailResponse(loginSelector.response?.data)?.role_id,
      })
    );
  }, [dispatch, loginSelector]);

  const handleInputField = (e) => {
    const nextFormState = {
      ...form,
      [e.target.name]: e.target.value,
    };
    setForm(nextFormState);
  };
  const handleInputArea = (e) => {
    const nextFormState = {
      ...form,
      area: e,
      // address: e,
      latitude: "",
      longitude: "",
    };
    setForm(nextFormState);
  };
  const onSelect = (latLng, area) => {
    const nextFormState = {
      ...form,
      // address: address,
      area: area,
      latitude: latLng.lat,
      longitude: latLng.lng,
    };
    setForm(nextFormState);
  };

  const handleEdit = () => {
  
    if (!handleValid()) {

      const formData = new FormData();
      if (image.raw) {
        formData.append("profile_picture", image.raw);
      }
      formData.append("email", form.email);
      formData.append("gender", form.gender);
      formData.append("longitude", form.longitude);
      formData.append("latitude", form.latitude);
      if (form?.agent_id) {
        form?.primary_mobile &&
          form.mobile &&
          formData.append("primary_mobile", form.mobile);
        form?.date_of_birth &&
          formData.append("date_of_birth", form.dateofbirth);
        form?.location && formData.append("location", form.area);
        form?.agent_name && formData.append("agent_name", form.agent_name);
        form?.agent_id && formData.append("agent_id", form.agent_id);

        dispatch(editAgentProfileUpdate(formData));
      } else {
        form?.user_id && formData.append("user_id", form.user_id);
        form.role_id && formData.append("role_id", form.role_id);
        form?.firstname && formData.append("firstname", form.firstname);
        form?.lastname && formData.append("lastname", form.lastname);
        form?.mobile && form.mobile && formData.append("mobile", form.mobile);
        form?.dateofbirth && formData.append("dateofbirth", form.dateofbirth);
        form?.address && formData.append("address", form.address);
        form?.city && formData.append("city", form.city);
        form?.city_id && formData.append("city_id", form.city_id);
        form.area && formData.append("area", form.area);
        form.justo_employee_code && formData.append("justo_employee_code",form.justo_employee_code)
        dispatch(editUserProfileUpdate(formData));
      }
    }
  };

  const handleValid = () => {
    let err = {};
    let formError = false;
 
      if (!form.firstname) {
        formError = true;
        err["firstname"] = strings.firstnameErr;
      } else if (!nameValid(form.firstname)) {
        formError = true;
        err["firstname"] = strings.nameValidErr;
      }
      if (!form.lastname) {
        formError = true;
        err["lastname"] = strings.lastnameErr;
      } else if (!nameValid(form.lastname)) {
        formError = true;
        err["lastname"] = strings.nameValidErr;
      }
      // if (!form.address) {
      //   formError = true;
      //   err["address"] = strings.addressErr;
      // }
      if (!form.city_id) {
        formError = true;
        err["city_id"] = strings.cityErr;
      } else if (form.city_id === strings.city) {
        formError = true;
        err["city_id"] = strings.cityErr;
      }
    
    // if (!form.mobile) {
    //   formError = true;
    //   err["mobile"] = strings.mobileErr;
    // } else if (!mobileNumberValid(form.mobile)) {
    //   formError = true;
    //   err["mobile"] = strings.mobileValidErr;
    // }

    
    if (Number(form.gender) === 1 || Number(form.gender) === 2) {
      // formError = false;
    } else {
      formError = true;
      err["gender"] = strings.genderErr;
    }
    if (!form.dateofbirth) {
      formError = true;
      err["dateofbirth"] = strings.dateofbirthErr;
    } else if (getAge(form.dateofbirth) < 18) {
      formError = true;
      err["dateofbirth"] = strings.dateofbirthErr2;
    }

    if (!form.area) {
      formError = true;
      err["area"] = strings.areaErr;
    } 
    // else if (!form.longitude) {
    //   formError = true;
    //   err["area"] = strings.validAddressErr;
    // } else if (form.longitude === "undefined") {
    //   formError = true;
    //   err["area"] = strings.validAddressErr;
    // }

    
    setFormVaild(err);
    return formError;
  };
  useEffect(() => {
    seo({
      title: "Edit Profile",
      metaDescription: "Edit profile",
      canonicalLink: window.location.href,
    });
  }, []);
  return (
    <div className="page-body">
      <Breadcrumb
        title={strings.editprofile}
        url={"/dashboard"}
        parentListing={strings.dashboardProfile}
        titleactive={strings.editProfile}
        isBackBtn={true}
      />
      <div className="container-fluid">
        <div className="row ">
          <div className="col-sm-12 ">
            <div className="card">
              <div className="card-header pb-0">
                <h5>{strings.editProfile}</h5>
              </div>
              <form className="form theme-form">
                <div className="card-body">
                  <div className="row ">
                    <div className="col-md-2">
                      <label
                        htmlFor="upload-button"
                        className="breadcrumb-item"
                        style={{
                          display: "inline-flex",
                          justifyContent: "center",
                        }}
                      >
                        <ProfileAvatar
                          variant="default"
                          preview={image.preview}
                          alt={strings.editImage}
                          width={150}
                          height={150}
                          className="profile-edit-avatar"
                          title={strings.editImage}
                        />
                      </label>
                      <input
                        type="file"
                        id="upload-button"
                        style={{ display: "none" }}
                        onChange={handleChange}
                      />
                      <br />
                    </div>
                  </div>
                  {formVaild.validMedia && (
                    <span style={{ color: "red" }}>{formVaild.validMedia}</span>
                  )}
                  {form?.agent_name && (
                    <div className="row">
                      <div className="col-md-8">
                        <div className="mb-3">
                          <Input
                            type="text"
                            name="agent_name"
                            placeholder={strings.agent_name}
                            value={form.agent_name}
                            onChange={handleInputField}
                            autoComplete="off"
                            label={strings.agent_name}
                            requiredLabel={true}
                            error={formVaild.agent_name}
                          />
                        </div>
                      </div>
                    </div>
                  )}
                  {!form?.agent_name && (
                    <div className="row ">
                      <div className="col-md-8 ">
                        <div className="mb-3">
                          <Input
                            type="text"
                            name="firstname"
                            placeholder={strings.firstName}
                            value={form.firstname}
                            onChange={handleInputField}
                            autoComplete="off"
                            label={strings.firstName}
                            requiredLabel={true}
                            error={formVaild.firstname}
                          />
                        </div>
                      </div>
                    </div>
                  )}
                  {!form?.agent_name && (
                    <div className="row">
                      <div className="col-md-8">
                        <div className="mb-3">
                          <Input
                            type="text"
                            name="lastname"
                            placeholder={strings.lastName}
                            value={form.lastname}
                            onChange={handleInputField}
                            autoComplete="off"
                            label={strings.lastName}
                            requiredLabel={true}
                            error={formVaild.lastname}
                          />
                        </div>
                      </div>
                    </div>
                  )}
                  <div className="row">
                    <div className="col-md-8">
                      <div className="mb-3">
                        <Input
                          type="email"
                          placeholder={strings.emailaddress}
                          readOnly
                          name="email"
                          value={form.email}
                          onChange={handleInputField}
                          autoComplete="off"
                          label={strings.emailAddress}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-md-8">
                      <div className="mb-3">
                        <Input
                          type="text"
                          maxLength={10}
                          placeholder={strings.mobileNo}
                          name="mobile"
                          value={form.mobile}
                          onChange={handleInputField}
                          autoComplete="off"
                          readOnly
                          label={strings.mobileNo}
                        />
                        {formVaild.mobile && (
                          <span style={{ color: "red" }}>
                            {formVaild.mobile}
                          </span>
                        )}
                      </div>
                    </div>
                  </div>
                  <div className="row pb-3">
                    <div className="row pl-4">
                      <label htmlFor="exampleInputMobileNo " className="pr-4">
                        {strings.gender}
                        <span className="required-field"></span>
                      </label>
                      <div className="form-check pr-4">
                        <input
                          className="form-check-input "
                          type="radio"
                          name="gender"
                          value={1}
                          checked={Number(form.gender) === 1 ? true : false}
                          onChange={handleInputField}
                        />

                        <label
                          className="form-check-label"
                          htmlFor="flexRadioDefault1"
                        >
                          {strings.male}
                        </label>
                      </div>
                      <div className="form-check">
                        <input
                          className="form-check-input"
                          type="radio"
                          name="gender"
                          value={2}
                          checked={Number(form.gender) === 2 ? true : false}
                          onChange={handleInputField}
                        />
                        <label
                          className="form-check-label"
                          htmlFor="flexRadioDefault2"
                        >
                          {strings.female}
                        </label>
                      </div>
                    </div>
                    {formVaild.gender && (
                      <span style={{ color: "red" }}>{formVaild.gender}</span>
                    )}
                  </div>
                  <div className="row">
                    <div className="col-md-8">
                      <div className="mb-3">
                        <Input
                          type="date"
                          placeholder={strings.dob}
                          name="dateofbirth"
                          value={form.dateofbirth}
                          onChange={handleInputField}
                          label={strings.dob}
                          requiredLabel={true}
                          error={formVaild.dateofbirth}
                        />
                      </div>
                    </div>
                  </div>
                  {form?.city_id && (
                    <div className="row">
                      <div className="col-md-8">
                        <div className="mb-3">
                          <label htmlFor="exampleFormControlSelect9">
                            {strings.city}
                            <span className="required-field"></span>
                          </label>
                          <Select
                            isSearchable
                            isClearable={true}
                            options={cityData}
                            getOptionLabel={(option) => `${option.city_name}`}
                            getOptionValue={(option) => option.city_id}
                            name="cityObj"
                            value={form.cityObj}
                            onChange={(val) => {
                              const nextFormState = {
                                ...form,
                                cityObj: val,
                              };
                              if (val) {
                                nextFormState.city = val?.city_name;
                                nextFormState.city_id = val?.city_id;
                              } else {
                                nextFormState.city = "";
                                nextFormState.city_id = "";
                              }
                              setForm(nextFormState);
                            }}
                          />
                          {formVaild.city_id && (
                            <span style={{ color: "red" }}>
                              {formVaild.city_id}
                            </span>
                          )}
                        </div>
                      </div>
                    </div>
                  )}
                  {/* {form?.address && (
                    <div className="row">
                      <div className="col-md-8">
                        <div className="mb-3">
                          <Input
                            type="text"
                            placeholder={strings.address}
                            name="address"
                            value={form.address}
                            onChange={handleInputField}
                            autoComplete="off"
                            label={strings.address}
                            requiredLabel={true}
                            error={formVaild.address}
                          />
                        </div>
                      </div>
                    </div>
                  )} */}
                  <div className="row">
                    <div className="col-md-8">
                      <div className="mb-3">
                        <AutocompletePlace
                          placeholder={strings.area}
                          value={form.area}
                          onChange={handleInputArea}
                          onSelect={onSelect}
                          error={formVaild.area}
                          label={strings.area}
                          requiredLabel={true}
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-12 ">
                    <div className="card-footer float-right">
                      <button
                        className="btn btn-color"
                        type="button"
                        onClick={() => handleEdit()}
                      >
                        {strings.update}
                      </button>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default UserEditPorfile;
